/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Telegram = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="m9.77998 18.65.28002-4.23 7.68-6.92003c.34-.31-.07-.46-.52-.19l-9.48002 5.99003-4.1-1.3c-.88-.25-.89-.86.2-1.3l15.97002-6.16003c.73-.33 1.43.18 1.15 1.3l-2.72 12.81003c-.19.91-.74 1.13-1.5.71l-4.14-3.06-1.99 1.93c-.23.23-.42.42-.83002.42z"
    />
  </Icon>
);
